module.exports = __webpack_public_path__ + "static/media/Necchi - Bordeaux - White_Turquoise.057b49fd.jpg";